import { getMobileOperatingSystem } from 'nove8/helpers/getMobileOperatingSystem'
import { getOperatingSystemVersion } from 'nove8/helpers/getOperatingSystemVersion'
import { CurrentEnvironment } from 'root-constants'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const getCommonEventProps = (
  utmTags: Record<string, string>,
): Record<string, unknown> => {
  const cohort =
    useZustandStore.getState()?.lead?.cohort ||
    useZustandStore.getState()?.initialCohort ||
    ''
  const {
    isWebAppRedirect,
    isPrintablePdf,
    language,
  } = useZustandSessionStore.getState()
  const printableFromQuery = utmTags.printable_pdf === 'true'
  const webappRedirectFromQuery = utmTags.webapp_redirect === 'true'

  return {
    is_prod_env: import.meta.env.CURRENT_ENV === CurrentEnvironment.PROD,
    cohort,
    lang: language,
    device_type: getMobileOperatingSystem(),
    operating_system_version: getOperatingSystemVersion(),
    attribution: utmTags,
    viewport_width: window.screen.width,
    viewport_height: window.screen.height,
    viewport_size: `${window.screen.width}x${window.screen.height}`,
    webapp_redirect: webappRedirectFromQuery || isWebAppRedirect,
    printable_pdf: printableFromQuery || isPrintablePdf,
  }
}
